import axios from 'axios'

const funcs = {
	async LoginDDOPA(lnameWrite, menu) {
		let response
		// let query = `?menu=${menu}`
		// if (Number(menu) == 1) {
		// 	query += `&lnameWrite=${lnameWrite}`
		// }
		try {
			funcs.setCookie('menu', menu, 1)
			funcs.setCookie('lnameWrite', lnameWrite, 1)
			response = await axios.get("./connectAPI/ddopa-login.php")
			// response = await axios.get("./DPA/ddopa-login.php")
			// console.log(response);
			if (response.status == 200) {
				window.location.href = response.data
			}
		} catch (error) {
			console.log(error);
		}
	},
	async getCallback() {


		let response = {
			menu: funcs.getCookie('menu'),
			lnameWrite: funcs.getCookie('lnameWrite')
		}
		funcs.eraseCookie('menu')
		funcs.eraseCookie('lnameWrite')
		return response
		// try {
		// 	response = await axios.get("./connectAPI/ddopa_getCallback.php")
		// 	// response = await axios.get("./DPA/ddopa_getCallback.php")
		// } catch (error) {
		// 	console.log(error);
		// }
		// return response
	},
	setCookie(name, value, days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	},
	getCookie(name) {
		var cookies = document.cookie;
		var parts = cookies.split(name + "=");
		var cookieValue = '';
		if (parts.length == 2) {
			cookieValue = parts.pop().split(";").shift();
		}
		return cookieValue;
	},
	eraseCookie(name) {
		document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}
}


export default funcs